import { faChevronRight } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Toaster } from '@repo/videa-components/src/index';
import classNames from 'classnames';
import { useAtom } from 'jotai';
import { useHistory } from 'react-router-dom';

import { usePreferences } from '@/react-query/usePreferences';
import routesConstants from '@/routes/routes.constants';

import { isOnUpdatePageAtom, selectedPracticeGroupAtom } from './atoms';
import { UpdatePracticeGroups } from './UpdatePracticeGroups';
import { ViewPracticeGroups } from './ViewPracticeGroups';

const HeaderItem = ({
  children,
  dataCy,
  onClick,
  selected,
}: {
  children: React.ReactNode;
  dataCy?: string;
  onClick: () => void;
  selected?: boolean;
}) => {
  return (
    <button
      className={classNames(
        'vai-block vai-font-inter vai-cursor-pointer vai-border-0 vai-bg-transparent vai-p-0 vai-m-0 vai-outline-none focus:vai-ring-0 select-none focus:vai-outline-none active:vai-bg-transparent',
        'hover:vai-text-gray-600',
        !selected && 'vai-text-muted-foreground vai-border-transparent',
        selected && 'vai-text-gray-600',
      )}
      data-cy={dataCy}
      onClick={onClick}
    >
      {children}
    </button>
  );
};

export const PracticeGroups = () => {
  const [isOnUpdatePage, setIsOnUpdatePage] = useAtom(isOnUpdatePageAtom);
  const [selectedPracticeGroup, setSelectedPracticeGroup] = useAtom(
    selectedPracticeGroupAtom,
  );

  const history = useHistory();
  const { data: prefs } = usePreferences();

  return (
    <div className="vai-flex vai-flex-col vai-gap-8 vai-w-full vai-pb-0 vai-p-8">
      <div className="vai-flex vai-flex-row vai-gap-4 vai-items-center">
        <HeaderItem
          onClick={() =>
            history.push(
              prefs?.enableInsightsPOC
                ? `${routesConstants.INSIGHTS}`
                : `${routesConstants.SWITCHBOARD}`,
            )
          }
        >
          Insights
        </HeaderItem>
        <FontAwesomeIcon icon={faChevronRight} color="gray" />
        <HeaderItem
          onClick={() => {
            setIsOnUpdatePage(false);
            setSelectedPracticeGroup(undefined);
          }}
          selected={!isOnUpdatePage}
        >
          DSO Regions
        </HeaderItem>
        {isOnUpdatePage && (
          <FontAwesomeIcon icon={faChevronRight} color="gray" />
        )}
        {isOnUpdatePage && (
          <HeaderItem
            onClick={() => setIsOnUpdatePage(true)}
            selected={isOnUpdatePage}
          >
            {selectedPracticeGroup ? 'Edit Region' : 'Create New'}
          </HeaderItem>
        )}
      </div>
      {!isOnUpdatePage && <ViewPracticeGroups />}
      {isOnUpdatePage && <UpdatePracticeGroups />}
      <Toaster theme="light" />
    </div>
  );
};
